// extracted by mini-css-extract-plugin
export var circle = "_3v-2";
export var icon = "_3v-a";
export var iconHighlight = "_3v-0";
export var lg = "_3v-8";
export var md = "_3v-7";
export var outline = "_3v-4";
export var sm = "_3v-6";
export var square = "_3v-1";
export var xl = "_3v-9";
export var xs = "_3v-5";
export var xxs = "_3v-3";